export default __webpack_public_path__ + "static/media/liquipedia_icon_display.12cd0044.png";